// JOBE-0106: AskBar — UI mock per the rollout plan's Phase 5
// Out-of-scope. Accepts text input; on submit, displays a static
// placeholder and clears the input. NO fetch. The scope chip reads
// `counts` to render `scope: <project-slug> · N docs · M entities`.

import React, { useState } from 'react';

export const ASK_BAR_PREVIEW_RESPONSE =
  'Ask is in preview — the project-scoped backend is not yet wired'
  + ' (see ADR-0023 rollout plan §Out of scope).';

function urnTail(urn) {
  if (!urn || typeof urn !== 'string') return '';
  return urn.split(':').pop() || urn;
}

export function AskBar({ project, counts }) {
  const [value, setValue] = useState('');
  const [response, setResponse] = useState('');

  const documents = counts?.documents ?? 0;
  const entities = counts?.entities_by_kind
    ? Object.values(counts.entities_by_kind).reduce((a, b) => a + b, 0)
    : 0;
  const slug = project?.slug || urnTail(project?.urn || '');

  const onSubmit = (e) => {
    e.preventDefault();
    if (!value.trim()) return;
    setResponse(ASK_BAR_PREVIEW_RESPONSE);
    setValue('');
  };

  return (
    <form
      className="project-ask-bar"
      onSubmit={onSubmit}
      data-testid="project-ask-bar"
    >
      <input
        type="text"
        className="project-ask-input"
        placeholder="Ask Jobe about this project…"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        data-testid="project-ask-input"
      />
      <span className="project-ask-scope mono" data-testid="project-ask-scope">
        scope: {slug || 'project'} · {documents} docs · {entities} entities
      </span>
      <button type="submit" className="project-ask-submit">Ask</button>
      {response ? (
        <div className="project-ask-response" data-testid="project-ask-response">
          {response}
        </div>
      ) : null}
    </form>
  );
}
